'use client'
import { useContext, useEffect } from 'react'
import { FormContext } from '@/components/Form'

export function useSetValueFromForm(name: any, setValue: (value: any) => void) {
  const formContext = useContext(FormContext)

  useEffect(() => {
    let unsubscribe = () => {}
    if (formContext) {
      unsubscribe = formContext.on('change_' + name, (value) => {
        setValue(value)
      })
    }
    return unsubscribe
  }, [setValue, name, formContext])
}
